export default function getDefaultFiltersObj() {
  return {
    connector: 'All',
    filterGroups: []
  };
}
